import { useRef } from 'react';
import { toPng } from 'html-to-image';

export default function OGImage() {
  const imageRef = useRef<HTMLDivElement>(null);

  const handleDownload = async () => {
    if (!imageRef.current) return;

    try {
      const dataUrl = await toPng(imageRef.current, {
        width: 1200,
        height: 630,
        pixelRatio: 1, // Exact dimensions for OG
      });

      const link = document.createElement('a');
      link.download = 'og-image.png';
      link.href = dataUrl;
      link.click();
    } catch (err) {
      console.error('Failed to generate image:', err);
    }
  };

  return (
    <>
      <div
        ref={imageRef}
        className="relative overflow-hidden"
        style={{
          width: '1200px',
          height: '630px',
          background: 'linear-gradient(150deg, rgba(0, 52, 184, 1) 0%, rgba(43, 97, 235, 1) 41%, rgba(121, 60, 236, 1) 89%)'
        }}
      >
      {/* Avodah Logo - Upper Left */}


      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-20">
        {/* Logo/Icon */}
        {/* <div
          className="text-white p-6 rounded-3xl mb-8"
          style={{
            background: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(10px)',
            position: 'absolute',
            top: '10px',
            right: '10px'
          }}
        >
          <svg className="w-20 h-20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div> */}

        <div
          className="text-white p-6 rounded-3xl mb-8"
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            filter: 'drop-shadow(0 0 20px rgba(255, 255, 255, 0.8)) drop-shadow(0 0 40px rgba(255, 255, 255, 0.4))'
          }}
        >
          <img src="/avodah-logo.png" alt="Avodah" style={{ height: '120px' }} className="opacity-90" />
        </div>

        {/* Title */}
        <h1
          className="text-white font-bold mb-6"
          style={{
            fontFamily: '"Noto Serif", serif',
            fontSize: '140px',
            lineHeight: '1.1',
            letterSpacing: '-0.02em'
          }}
        >
          21-Day<br />AI Challenge
        </h1>

        {/* Subtitle */}
        <p
          className="text-white/90 max-w-3xl"
          style={{
            fontFamily: '"Special Gothic", sans-serif',
            fontSize: '48px',
            lineHeight: '1.4',
            fontWeight: '400'
          }}
        >
          Your onramp to endless possibilities, delivered fresh to your inbox
        </p>
      </div>
    </div>

    <div className="mt-8 text-center">
      <button
        onClick={handleDownload}
        className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
      >
        Download PNG
      </button>
    </div>
    </>
  );
}
